import { useState } from 'react'

export const useMessage = () => {
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState('')

  const showMessage = (text, type = 'success') => {
    setMessage(text)
    setMessageType(type)
    setTimeout(() => {
      setMessage('')
      setMessageType('')
    }, 3000)
  }

  const clearMessage = () => {
    setMessage('')
    setMessageType('')
  }

  return {
    message,
    messageType,
    showMessage,
    clearMessage
  }
}